export default __webpack_public_path__ + "static/media/shortened.c1b925c6.gif";